<template>
  <div class="main-app">
    <ContactForm />
  </div>
</template>

<script src="./WyreContactApp.js" lang="js"></script>
